module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/post/post-detail/post-detail.component.css
// module id = ./src/app/admin/lookup-management/post/post-detail/post-detail.component.css
// module chunks = main